import React, { useEffect, useMemo, useState } from 'react';
import CryptoJS from 'crypto-js';
import api from '../api';
import './estilodash.css';

const GERADORES = {
  ea: (conta) => CryptoJS.MD5(String(Number(conta) * 11 - 181818)).toString(CryptoJS.enc.Hex),
  bias: (conta) => CryptoJS.SHA1(`BIAS:${conta}:QT`).toString(),
  ragnarok: (conta) => CryptoJS.SHA256(`RAGNAROK:${conta}:QT`).toString(CryptoJS.enc.Hex),
};

export default function AdicionaLicencas() {
  const [clientes, setClientes] = useState([]);
  const [assinaturas, setAssinaturas] = useState([]);
  const [licencas, setLicencas] = useState([]);
  const [clienteId, setClienteId] = useState('');
  const [assinaturaId, setAssinaturaId] = useState('');
  const [produtoId, setProdutoId] = useState('');
  const [produtoCodigo, setProdutoCodigo] = useState('');
  const [conta, setConta] = useState('');
  const [chave, setChave] = useState('');
  const [tipo, setTipo] = useState('Real');
  const [status, setStatus] = useState('1');
  const [dateExp, setDateExp] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    Promise.all([
      api.get('/api/clientes'),
      api.get('/api/assinaturas'),
      api.get('/api/licencas-v2'),
    ]).then(([c, a, l]) => {
      setClientes(c.data || []);
      setAssinaturas(a.data || []);
      setLicencas(l.data || []);
    }).catch(console.error);
  }, []);

  const assinaturasCliente = useMemo(() => assinaturas.filter(a => String(a.cliente_id) === String(clienteId)), [assinaturas, clienteId]);
  const assinaturaAtual = assinaturasCliente.find(a => String(a.id) === String(assinaturaId));

  const produtosPermitidos = useMemo(() => {
    if (!assinaturaAtual) return [];
    if (assinaturaAtual.produto_id) {
      return [{ id: assinaturaAtual.produto_id, codigo: assinaturaAtual.codigo_plano, nome: assinaturaAtual.nome_plano }];
    }
    const codigo = assinaturaAtual.codigo_plano;
    if (codigo === 'completo') {
      return [
        { id: 1, codigo: 'ea', nome: 'Quantum Trades EA' },
        { id: 2, codigo: 'bias', nome: 'QuantumTrades Bias' },
        { id: 3, codigo: 'ragnarok', nome: 'QuantumTrades Ragnarok' },
      ];
    }
    return [];
  }, [assinaturaAtual]);

  const handleGerar = () => {
    if (!conta || !produtoCodigo) return alert('Selecione produto e informe conta.');
    const fn = GERADORES[produtoCodigo] || GERADORES.ea;
    setChave(fn(conta));
  };

  const salvar = async (e) => {
    e.preventDefault();
    if (!clienteId || !assinaturaId || !produtoId || !conta || !chave) {
      return alert('Preencha cliente, assinatura, produto, conta e chave.');
    }
    const dup = licencas.find(l => String(l.conta) === String(conta) && String(l.produto_id) === String(produtoId));
    if (dup) return alert('Já existe licença para essa conta nesse produto.');

    await api.post('/api/licencas-v2', {
      cliente_id: Number(clienteId),
      assinatura_id: Number(assinaturaId),
      produto_id: Number(produtoId),
      conta,
      lkey: chave,
      status,
      tipo,
      date_exp: dateExp || null,
    });
    setMsg('Licença criada com sucesso no modelo novo.');
    setConta(''); setChave(''); setDateExp('');
    const l = await api.get('/api/licencas-v2');
    setLicencas(l.data || []);
  };

  return (
    <div className="pagamentos-container">
      <h2>Adicionar Licença (novo modelo)</h2>
      <p>Um único menu basta. O cálculo da chave muda conforme o produto selecionado.</p>
      {msg && <p>{msg}</p>}
      <form onSubmit={salvar}>
        <div className="form-linha">
          <label>Cliente
            <select value={clienteId} onChange={(e) => { setClienteId(e.target.value); setAssinaturaId(''); setProdutoId(''); setProdutoCodigo(''); }}>
              <option value="">Selecione</option>
              {clientes.map(c => <option key={c.id} value={c.id}>{c.id} - {c.nome}</option>)}
            </select>
          </label>
          <label>Assinatura
            <select value={assinaturaId} onChange={(e) => { setAssinaturaId(e.target.value); setProdutoId(''); setProdutoCodigo(''); }}>
              <option value="">Selecione</option>
              {assinaturasCliente.map(a => <option key={a.id} value={a.id}>{a.nome_plano} ({a.tier})</option>)}
            </select>
          </label>
        </div>
        <div className="form-linha">
          <label>Produto
            <select value={produtoId} onChange={(e) => {
              const p = produtosPermitidos.find(x => String(x.id) === String(e.target.value));
              setProdutoId(e.target.value);
              setProdutoCodigo(p?.codigo || '');
            }}>
              <option value="">Selecione</option>
              {produtosPermitidos.map(p => <option key={p.codigo} value={p.id}>{p.nome}</option>)}
            </select>
          </label>
          <label>Conta MT5
            <input value={conta} onChange={(e) => setConta(e.target.value)} />
          </label>
        </div>
        <div className="form-linha">
          <label>Tipo
            <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
              <option value="Real">Real</option>
              <option value="Demo">Demo</option>
            </select>
          </label>
          <label>Status
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="1">Ativa</option>
              <option value="0">Inativa</option>
            </select>
          </label>
          <label>Expiração
            <input type="date" value={dateExp} onChange={(e) => setDateExp(e.target.value)} />
          </label>
        </div>
        <div className="form-linha">
          <label>Chave (lkey)
            <input value={chave} onChange={(e) => setChave(e.target.value)} />
          </label>
        </div>
        <div className="barra-acoes-pagamento">
          <button type="button" onClick={handleGerar}>Gerar chave</button>
          <button type="submit">Salvar licença</button>
        </div>
      </form>
    </div>
  );
}
